import { atomWithReset } from 'jotai/utils'
import { InsiConnectInsRequest, InsiResponsePatient } from '../../model/Insi'

interface InsiConsultResponseError {
  error?: string
  codeCR?: string
}

interface InsiConsultRequestState {
  search: InsiConnectInsRequest | null
  onReceivePatient: (patient: InsiResponsePatient | null) => void
  onError: (error?: InsiConsultResponseError | string) => void
}

export const insiConsultRequestAtom = atomWithReset<InsiConsultRequestState | null>(null)
